<template>
  <bxp-form-framework
    sidebar-background="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2022/06/bXP-contact-left-bg-scaled.jpg"
  >
    <template v-slot:sidebar-primary-text>
      <strong>Need some help? It’s closer than you think.</strong>
    </template>
    <template v-slot:sidebar-secondary-text>
       If we haven't covered your questions in the
        <a href="/bountixp-faqs">FAQs</a>, send us your details and a message of
        enquiry and we'll get back to you with an answer, pronto!
    </template>
    <template v-slot:main-content>
      <form-wizard />
      <!-- <ContactForm /> -->
    </template>
  </bxp-form-framework>
</template>

<script>
// import ContactForm from "./components/steps/ContactForm.vue";
export default {
  name: "app",
};
</script>

<style>
/* Wizard overrides *************************/
.tab-navigation {
  box-shadow: none !important;
}
@media only screen and (max-width: 767px){
  .bxp-main {
    display: block;
  }
  .bxp-layout-sidebar {
    display: block;
    min-width: 100% !important;
    width: 100%;
    min-height: auto;
    margin-top: 100px;
    padding: 0px 20px 90px 20px;
    background-position: top -255px right -227px;
    background-size: 150%;
  }
  .bxp-layout-sidebar-content p {
    display: block;
    width: 100%;
    max-width: 315px;
  }
  .bxp-sidebar-primary-text {
    color: #282829;
    font-family: Roboto;
    font-size: 31px;
    letter-spacing: 0;
    line-height: 40px;
    margin-block: 10px !important;
  }
  .bxp-sidebar-secondary-text {
    color: #535354;
    font-family: "Open Sans";
    font-size: 14px;
    letter-spacing: 0;
    line-height: 22px;
    margin-bottom: 0px !important;
  }
  .bxp-desktop-header {
    display: block !important;
  }
  .bxp-mobile-header {
    display: none !important;
  }
  body .bxp-form,
  body .office-header,
  body .loc-1-header,
  body .loc-1-address,
  body .loc-2-header,
  body .loc-1-address,
  body .bxp-layout-sidebar-content {
    width: 100% !important;
  }
  body .schedule-a-conversatation {
    width: 100%;
    color: #282829;
    font-family: Roboto;
    font-size: 15px !important;
    letter-spacing: 0;
    line-height: 20px !important;
    height: auto;
  }

  body .divider-line {
    margin-top: 35px;
  }
  body .contact-us-gridlayout {
    display: block;
    padding-top: 30px;
  }

  .bxp-layout-content {
    padding: 30px 20px !important;
  }

  body .get-in-touch-heading{
    font-size: 24px !important;
    line-height: 36px !important;
    margin-block: 2px !important;
  }

  .step-content {
    padding: 0 !important;
  }

  body .contact-us-gridlayout .v-input__prepend-inner {
    display: none !important;
  }

  body .contact-us-gridlayout .v-text-field {
    margin-top: 0 !important;
    padding-top: 5px;
  }

  body .agree-row {
    margin-top: 5px;
  }
  .agree-row .v-input__slot {
    display: block;
    text-align: center;
  }

  body .navigation-wrapper {
    text-align: center;
    width: 100%;
  }

  .bxp-btn.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: #fff !important;
    border-color: var(--v-primary-base) !important;
    color:#c7c7c7 !important;
  }

  .bxp-desktop-header .divider-line-office {
    margin-top: 35px;
  }
  body .pin-img {
    width: 17px;
    height: 23px;
    margin-top: -1px;
  }

  body .office-header-text {
    font-size: 24px;
    letter-spacing: 0;
    line-height: 23px;
    height: auto;
  }
  body .loc-1-header,
  body .loc-2-header {
    font-size: 15px;
    letter-spacing: 0;
    line-height: 20px;
  }

  body .loc-2-header {
    margin-top: 30px;
  }

  body .loc-1-address {
    margin-top: 5px;
  }

  body .agree-row {
    display: block;
  }
}
</style>
